"use strict";

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LambdasClient = void 0;

var dcl_catalyst_commons_1 = require("dcl-catalyst-commons");

var Helper_1 = require("./utils/Helper");

var LambdasClient = /*#__PURE__*/function () {
  function LambdasClient(lambdasUrl, fetcher) {
    _classCallCheck(this, LambdasClient);

    this.lambdasUrl = Helper_1.sanitizeUrl(lambdasUrl);
    this.fetcher = fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher({
      headers: Helper_1.getHeadersWithUserAgent('lambdas-client')
    });
  }

  _createClass(LambdasClient, [{
    key: "fetchProfiles",
    value: function fetchProfiles(ethAddresses, profileOptions, options) {
      var queryParams = new Map();
      queryParams.set('id', ethAddresses);

      if (profileOptions === null || profileOptions === void 0 ? void 0 : profileOptions.fields) {
        var fieldsValue = profileOptions === null || profileOptions === void 0 ? void 0 : profileOptions.fields.getFields();
        queryParams.set('fields', [fieldsValue]);
      }

      return Helper_1.splitAndFetch({
        fetcher: this.fetcher,
        baseUrl: this.lambdasUrl,
        path: '/profiles',
        queryParams: queryParams,
        options: options
      });
    }
  }, {
    key: "fetchWearables",
    value: function fetchWearables(filters, options) {
      var queryParams = Helper_1.convertFiltersToQueryParams(filters);

      if (queryParams.size === 0) {
        throw new Error('You must set at least one filter');
      }

      return Helper_1.splitAndFetchPaginated({
        fetcher: this.fetcher,
        baseUrl: this.lambdasUrl,
        path: '/collections/wearables',
        queryParams: queryParams,
        uniqueBy: 'id',
        elementsProperty: 'wearables',
        options: options
      });
    }
  }, {
    key: "fetchOwnedWearables",
    value: function fetchOwnedWearables(ethAddress, includeDefinitions, options) {
      return Helper_1.splitAndFetch({
        fetcher: this.fetcher,
        baseUrl: this.lambdasUrl,
        path: "/collections/wearables-by-owner/".concat(ethAddress),
        queryParams: {
          name: 'includeDefinitions',
          values: ["".concat(includeDefinitions)]
        },
        options: options
      });
    }
  }, {
    key: "fetchCatalystsApprovedByDAO",
    value: function fetchCatalystsApprovedByDAO(options) {
      return this.fetcher.fetchJson("".concat(this.lambdasUrl, "/contracts/servers"), options);
    }
  }, {
    key: "fetchLambdasStatus",
    value: function fetchLambdasStatus(options) {
      return this.fetcher.fetchJson("".concat(this.lambdasUrl, "/status"), options);
    }
  }, {
    key: "fetchPeerHealth",
    value: function fetchPeerHealth(options) {
      return this.fetcher.fetchJson("".concat(this.lambdasUrl, "/health"), options);
    }
  }, {
    key: "getLambdasUrl",
    value: function getLambdasUrl() {
      return this.lambdasUrl;
    }
  }]);

  return LambdasClient;
}();

exports.LambdasClient = LambdasClient;